import { DriverLanguage, driverLanguageNames, driverLanguageShortLabels } from "@/features/driver/i18n/translations";

interface LanguageSwitcherProps {
  value: DriverLanguage;
  onChange: (lang: DriverLanguage) => void;
  languages: DriverLanguage[];
  /** onDark: white-on-green header/footer. onLight: inside a white popover/menu. */
  variant?: "onDark" | "onLight";
  className?: string;
}

export default function LanguageSwitcher({ value, onChange, languages, variant = "onDark", className }: LanguageSwitcherProps) {
  if (languages.length < 2) {
    return null;
  }

  return (
    <div role="group" aria-label="Language" className={`flex items-center gap-1 ${className ?? ""}`}>
      {languages.map((lang) => {
        const isActive = value === lang;
        const activeClass = variant === "onDark" ? "bg-white text-europcarGreen" : "bg-europcarGreen text-white";
        const inactiveClass = variant === "onDark" ? "text-white/70 hover:text-white" : "text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900";

        return (
          <button
            key={lang}
            type="button"
            aria-pressed={isActive}
            aria-label={driverLanguageNames[lang]}
            onClick={() => onChange(lang)}
            className={`cursor-pointer rounded-md px-2.5 py-1 text-xs font-semibold transition-colors ${isActive ? activeClass : inactiveClass}`}
          >
            {driverLanguageShortLabels[lang]}
          </button>
        );
      })}
    </div>
  );
}
